import React from 'react';
interface HeroCursorProps {
  x: number;
  y: number;
}
export function HeroCursor({
  x,
  y
}: HeroCursorProps) {
  return <div className="pointer-events-none absolute left-0 top-0 z-40" style={{
    transform: `translate3d(${x}px, ${y}px, 0)`,
    willChange: 'transform'
  }} aria-hidden="true" data-id="element-90" data-mp="1u1sw4p4k3m2g">
      <svg width="20" height="24" viewBox="0 0 20 24" fill="none" style={{
      filter: 'drop-shadow(0 1px 4px rgba(0,0,0,0.18))'
    }} data-id="element-91" data-mp="22vo3m3t5hol9">
        <path d="M2.1 1.5L3.2 20.8L8.3 15.4L12.2 22L16.2 19.7L12.3 13.1L19 12.4L2.1 1.5Z" fill="#5B6FE6" stroke="#FFFFFF" strokeWidth="1.5" strokeLinejoin="round" data-id="element-92" data-mp="1b4rn8t7vt1t8" />
      </svg>
      <span className="pointer-events-none absolute left-[15px] top-[20px] whitespace-nowrap" style={{
      background: '#5B6FE6',
      color: '#FFFFFF',
      fontFamily: 'Aspekta, sans-serif',
      fontSize: 11,
      fontWeight: 500,
      lineHeight: '14px',
      padding: '2px 7px 3px',
      borderRadius: '0 6px 6px 6px',
      boxShadow: '0 1px 6px rgba(0,0,0,0.15)'
    }} data-id="element-93" data-mp="1k6hgm4lbqatn">
        you
      </span>
    </div>;
}